import NoImageSectionCard from "../../general/noImageSectionCard";
import StoriesHeroSection from "../storiesHeroSection";
import RightTopArrow from "../../../assets/figures/rightTopArrow";
import Button from "../../general/ui-blocks/elements/button";
import HorizontalSectionCard from "../../general/horizontalSectionCard";


export default function NextBigThingBodyComponent() {

    return (
        <div>

            <StoriesHeroSection title="Next Big Thing" titleAdvanced={
                <span><RightTopArrow/> Next <span className="brand-color">Big Thing</span></span>
            } blurb={
                <div>
                    <p>
                        Deployment day gets you past the finish line. Here's what you walk
                        away with and what it unlocks.
                    </p>
                </div>}
            />


            <NoImageSectionCard title={<strong>What Comes After</strong>} blurb={
                <div>
                    <p>
                        Most programs end with a certificate and a handshake. Extern Academy ends with
                        something you can point to, a shipped product, a recommendation from a real
                        founder, and a story that answers every "tell me about yourself" for years to
                        come. What you build here follows you forward.
                    </p>
                </div>
            } />

            <div className="bg-gray-200 pb-16 mb-12">

                <HorizontalSectionCard
                    title={<h1 className="text-4xl"><strong>Stand out, confidently.</strong></h1>}
                    blurb={<div
                        className="col-12 col-lg sas-ping-pong-content-tab position-relative d-flex align-items-center">
                        <div className="sas-ping-pong-content">
                            <p>
                                Top schools see thousands of applicants with perfect grades and identical
                                club lists. They're looking for the ones who've actually built something.
                                Your product, your role, and your ability to articulate what you learned
                                become the difference between "qualified" and "unforgettable."
                            </p>
                        </div>
                    </div>}
                    imageDirection="left"
                    primaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/7972556.webp"
                    primaryImageALT="College Applications"
                    secondaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/37822437.webp"
                    secondaryImageShouldMaxHeight={true}
                    secondaryImageALT="Students working"
                />

                <HorizontalSectionCard
                    title={<h1 className="text-4xl"><strong>Your first piece of reputation.</strong></h1>}
                    blurb={<div
                        className="col-12 col-lg sas-ping-pong-content-tab position-relative d-flex align-items-center">
                        <div className="sas-ping-pong-content">
                            <p>
                                Your reputation starts now. Your work becomes
                                your first piece of professional proof. This is something you can point to in
                                interviews, networking conversations, and even social settings. It's the
                                answer to "What have you done?" that impresses.
                            </p>
                        </div>
                    </div>}
                    imageDirection="right"
                    primaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/3184465.webp"
                    primaryImageALT="Professional networking"
                    secondaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/3184292.webp"
                    secondaryImageALT="Students collaborating"
                />

                {/* Alumni testimonial */}
                <div className="py-16 px-4 text-center" style={{ backgroundColor: "#1a1a1a" }}>
                    <div className="mx-auto" style={{ maxWidth: "680px" }}>
                        <p className="text-white mb-4" style={{ fontSize: "clamp(1.25rem, 2.5vw, 1.75rem)", lineHeight: "1.5", fontStyle: "italic" }}>
                            "I got into USC early decision. My interviewer spent half the call asking
                            about my Extern project. Nothing else on my application came close."
                        </p>
                        <p style={{ color: "#CDAF4B", fontWeight: "600", fontSize: "0.95rem", letterSpacing: "0.05em" }}>
                            — Maya R., Extern Academy alumna
                        </p>
                    </div>
                </div>

                <HorizontalSectionCard
                    title={<h1 className="text-4xl"><strong>You own one domain.</strong></h1>}
                    blurb={<div
                        className="col-12 col-lg sas-ping-pong-content-tab position-relative d-flex align-items-center">
                        <div className="sas-ping-pong-content">
                            <p>
                                At Extern Academy, everyone has a role — product, engineering, design,
                                growth, operations. You're not dabbling in everything. You go deep on
                                one function and build real expertise in a real environment. That depth
                                is what makes you credible, not just capable. And it's the kind of
                                focused ownership that catches the attention of every admissions officer,
                                hiring manager, and founder you'll meet.
                            </p>
                        </div>
                    </div>}
                    imageDirection="left"
                    primaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/3861964.webp"
                    primaryImageALT="Deep focus on one domain"
                    secondaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/4974914.webp"
                    secondaryImageALT="Student working in their specialization"
                />

                <HorizontalSectionCard
                    title={<h1 className="text-4xl"><strong>Proof you can deliver.</strong></h1>}
                    blurb={<div
                        className="col-12 col-lg sas-ping-pong-content-tab position-relative d-flex align-items-center">
                        <div className="sas-ping-pong-content">
                            <p>
                                In a startup environment, results matter more than titles. You'll leave
                                with a shipped product, real user feedback, and a track record of
                                execution under pressure. That proof fast‑tracks your path, whether
                                you're aiming for internships, scholarships, or your next venture.
                            </p>
                        </div>
                    </div>}
                    imageDirection="right"
                    primaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/7989091.webp"
                    primaryImageALT="Proof of work"
                    secondaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/7989095.webp"
                    secondaryImageALT="Product launch"
                />

                <HorizontalSectionCard
                    title={<h1 className="text-4xl"><strong>The people you work with remember you.</strong></h1>}
                    blurb={<div
                        className="col-12 col-lg sas-ping-pong-content-tab position-relative d-flex align-items-center">
                        <div className="sas-ping-pong-content">
                            <p>
                                Your Startup Trainer isn't an abstract authority figure. They're a founder
                                who worked alongside you, watched you make decisions under pressure, and
                                knows exactly what you're made of. When they vouch for you — in a letter,
                                on a call, on LinkedIn — it carries the weight of someone who was
                                actually there.
                            </p>
                        </div>
                    </div>}
                    imageDirection="left"
                    primaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/3182812.webp"
                    primaryImageALT="Mentor and student working together"
                    secondaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/1181396.webp"
                    secondaryImageALT="Founder giving feedback"
                />

                <HorizontalSectionCard
                    title={<h1 className="text-4xl"><strong>Credentials that open doors.</strong></h1>}
                    blurb={<div
                        className="col-12 col-lg sas-ping-pong-content-tab position-relative d-flex align-items-center">
                        <div className="sas-ping-pong-content">
                            <p>
                                You'll receive a certificate of completion and a letter of recommendation
                                from your Startup Trainer — a successful founder — that you can use for
                                college applications, internships, or any opportunity that asks who's
                                vouching for you. You'll also join a network of peers and mentors who
                                stay part of your journey long after demo day.
                            </p>
                            <div className="mt-4">
                                <p>
                                    This isn't the end. It's the start of a trajectory.
                                </p>
                            </div>
                        </div>
                    </div>}
                    imageDirection="right"
                    primaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/5428836.webp"
                    primaryImageALT="Certificate and credentials"
                    secondaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/267885.webp"
                    secondaryImageALT="Graduating students"
                    primaryButtonRow={
                        <div className="row flex-wrap mx-n2">
                            <Button text="START YOUR APPLICATION"
                                    ctaURL={"/apply"}
                                    target="_blank"/>
                        </div>
                    }
                />

            </div>
        </div>
    )
}
